<script lang="ts">
import { type PageLayoutProps } from './PageLayout.vue'
import { type RouterSelectMenuItem, type RouterSelectMenuProps } from '../../../router-components/router-select-menu.vue'
export interface PageLayoutPresetSubNavProps extends PageLayoutProps {
  sidebarProps?: RouterSelectMenuProps
  selectMenuItems?: RouterSelectMenuItem[]
}
</script>
<script setup lang="ts">
import PageLayout from './PageLayout.vue'
import { cn } from '@gat-ship/vue-components'
const props = withDefaults(defineProps<PageLayoutPresetSubNavProps>(), {
  selectMenuItems: () => []
})
</script>
<template>
  <PageLayout v-bind="props" :bodyProps="{
    class: 'flex-row'
  }">
    <template #actions>
      <slot name="actions" />
    </template>
    <router-select-menu :items="props.selectMenuItems" v-bind="props.sidebarProps">
      <template #append-select-menu v-if="$slots['append-select-menu']">
        <!-- Append elements after the select menu -->
        <slot name="append-select-menu" />
      </template>
      <template #select-menu-items v-if="$slots['select-menu-items']">
        <!-- Select menu items -->
        <slot name="select-menu-items" />
      </template>
      <template #prepend-select-menu v-if="$slots['prepend-select-menu']">
        <!-- Prepend elements before the select menu -->
        <slot name="prepend-select-menu" />
      </template>
    </router-select-menu>
    <div :class="cn('@container flex w-full flex-col gap-6', props.bodyProps?.class)
      ">
      <slot />
    </div>
  </PageLayout>
</template>
